import { navigateTo } from '../../../../external-dependencies/webapp-utils';

export const navigateToExternalPage = (url: string): void => {
  navigateTo(url);
};
